import React, { useEffect, useState } from 'react';
import './ViolationAlert.css';

const TYPE_LABELS = {
  tab_switch:        'Tab / Window Switch Detected',
  window_blur:       'Window Focus Lost',
  fullscreen_exit:   'Fullscreen Exited',
  right_click:       'Right-Click Blocked',
  copy_paste:        'Copy / Paste Blocked',
  keyboard_shortcut: 'Shortcut Blocked',
  devtools_open:     'DevTools Detected',
  page_refresh:      'Navigation / Refresh Blocked',
  multiple_tabs:     'Multiple Tabs Detected',
};

const TYPE_ICONS = {
  tab_switch:        '🔄',
  window_blur:       '👁️',
  fullscreen_exit:   '⛶',
  right_click:       '🖱️',
  copy_paste:        '📋',
  keyboard_shortcut: '⌨️',
  devtools_open:     '🛠️',
  page_refresh:      '🔃',
  multiple_tabs:     '🪟',
};

export default function ViolationAlert({ count, max, lastType, onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (count > 0) {
      setVisible(true);
      const t = setTimeout(() => {
        setVisible(false);
        onDismiss?.();
      }, 5000);
      return () => clearTimeout(t);
    }
  }, [count, lastType, onDismiss]);

  if (!visible) return null;

  const remaining = max - count;
  const isCritical = remaining <= 1;
  const label = TYPE_LABELS[lastType] || 'Violation Detected';
  const icon  = TYPE_ICONS[lastType]  || '⚠️';

  return (
    <div className={`violation-alert fade-up ${isCritical ? 'critical' : ''}`} role="alert" aria-live="assertive">
      <div className="va-icon">{icon}</div>
      <div className="va-body">
        <strong>{label}</strong>
        <span>
          {remaining <= 0
            ? 'Violation limit reached — test is being submitted!'
            : `Warning ${count} of ${max} — ${remaining} warning${remaining !== 1 ? 's' : ''} left before auto-submit`}
        </span>
        {isCritical && remaining > 0 && (
          <span className="va-critical-note">⚡ One more violation will terminate your test!</span>
        )}
      </div>
      <button
        className="va-close"
        onClick={() => { setVisible(false); onDismiss?.(); }}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
